import { render, staticRenderFns } from "./ItemChipAltNumber.vue?vue&type=template&id=6c678aa0&scoped=true"
import script from "./ItemChipAltNumber.vue?vue&type=script&lang=ts"
export * from "./ItemChipAltNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c678aa0",
  null
  
)

export default component.exports